import { useState, useEffect } from 'react';
import { format } from 'date-fns';

function isDateValid(dateStr) {
  return dateStr && !isNaN(new Date(dateStr));
}

function PassportSection({ title, params, isEdit, onValueChange }) {
  return (
    <div style={{
      borderRadius: '12px',
      border: '1px solid #e5e7eb',
      overflow: 'hidden',
      marginBottom: '16px',
    }}>
      {/* Заголовок секции */}
      <div style={{
        padding: '10px 16px',
        borderBottom: '1px solid #e5e7eb',
        background: '#f9fafb'
      }}>
        <p style={{
          fontSize: '11px',
          fontWeight: 600,
          color: '#6b7280',
          margin: 0,
          textTransform: 'uppercase',
          letterSpacing: '0.08em'
        }}>
          {title}
        </p>
      </div>

      {/* Строки */}
      <div style={{ background: '#ffffff' }}>
       {params.map((obj, index) => (
  <div key={obj.paramcode} style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    borderBottom: index !== params.length - 1 ? '1px solid #f3f4f6' : 'none',
    gap: '16px',
    background: index % 2 === 0 ? '#ffffff' : '#f9fafb', // ← чередование
  }}>
  <span style={{
    fontSize: '14px',
    color: '#6b7280',
    flexShrink: 0,
    width: isEdit ? '40%' : '45%', // ← больше места для инпута
    lineHeight: '1.5'
  }}>
    {obj.paramname}
  </span>

  {isEdit ? (
    <div style={{ width: '60%' }}> {/* ← обёртка для инпута */}
              {obj.libcode > 0 ? (
                <LibSelect
                  obj={obj}
                  onChange={(val) => onValueChange(obj.paramcode, val)}
                />
              ) : obj.paramtype == 3 ? (
                <input
                  type="date"
                  defaultValue={obj.paramvalue ? new Date(obj.paramvalue).toISOString().split('T')[0] : ''}
                  onChange={(e) => onValueChange(obj.paramcode, e.target.value)}
                  style={inputStyle}
                />
              ) : (
                <input
    type="text"
    defaultValue={obj.paramvalue || ''}
    onChange={(e) => {
      let val = e.target.value;
      if (obj.paramtype == 1) {
        val = val.replace(/[^0-9]/g, '');
        e.target.value = val;
      } else if (obj.paramtype == 2) {
        val = val.replace(/[^0-9.]/g, '');
        const parts = val.split('.');
        if (parts.length > 2) {
          val = parts[0] + '.' + parts.slice(1).join('');
        }
        e.target.value = val;
      }
      onValueChange(obj.paramcode, val);
    }}
    style={inputStyle}
  />
              )}</div>
            ) : (
              <span style={{
                fontSize: '14px',
                color: 'var(--text-primary)',
                fontWeight: 500,
                textAlign: 'right'
              }}>
                {obj.paramtype == 3 && isDateValid(obj.paramvalue)
                  ? format(new Date(obj.paramvalue), 'dd.MM.yyyy')
                  : obj.paramvalue || '—'}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function LibSelect({ obj, onChange }) {
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(String(obj.tparamvalue));

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/getParamsLib/${obj.libcode}`)
      .then(r => r.json())
      .then(data => {
        setOptions(data);
        setValue(String(obj.tparamvalue)); // ← устанавливаем значение после загрузки options
      })
      .catch(error => {
        console.error('Ошибка загрузки справочника параметра:', error);
      });
  }, [obj.libcode]);

  return (
    <select
      value={value} // ← value вместо defaultValue
      onChange={(e) => {
        setValue(e.target.value);
        onChange(e.target.value);
      }}
      style={inputStyle}
    >
      {options.map(o => (
        <option key={o.plcode} value={String(o.plcode)}>
          {o.plname}
        </option>
      ))}
    </select>
  );
}

const inputStyle = {
  padding: '8px 12px',
  fontSize: '14px',
  border: '1px solid #d1d5db',
  borderRadius: '8px',
  background: '#ffffff',
  color: '#111827',
  width: '100%',
  minWidth: 0,
  outline: 'none',
  boxSizing: 'border-box',
  transition: 'border-color 0.15s',
};

export function Passport({ id, typecode, name, isEdit, onValueChange }) {
  const [sections, setSections] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');
    const url = (typecode == 7 || typecode == 8)
      ? `${process.env.REACT_APP_BASE_URL}/api/object_params/getLineParams/${id}`
      : `${process.env.REACT_APP_BASE_URL}/api/object_params/getParams/${id}`;

    fetch(url)
      .then(r => r.json())
      .then(data => {
        const grouped = {};
        data.forEach(obj => {
          if (!grouped[obj.category_id]) {
            grouped[obj.category_id] = { title: obj.catname, params: [] };
          }
          grouped[obj.category_id].params.push(obj);
        });
        setSections(grouped);
        setLoading(false);
      })
      .catch(err => {
        console.error('Ошибка загрузки паспорта объекта:', err);
        setError('Не удалось загрузить паспорт объекта. Попробуйте снова.');
        setLoading(false);
      });
  }, [id, typecode, isEdit]);

  if (loading) {
    return (
      <div style={{ padding: '24px 16px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '14px' }}>
        Загрузка...
      </div>
    );
  }

  return (
    <div style={{ padding: '16px' }}>
      {/* Заголовок */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
        <div>
          <p style={{ fontSize: '17px', fontWeight: 500, margin: 0, color: 'var(--text-primary)' }}>
            {name}
          </p>
          <p style={{ fontSize: '13px', color: 'var(--text-muted)', margin: 0 }}>
            Паспорт объекта
          </p>
        </div>
      
      </div>

      {/* Секции */}
      {Object.values(sections).map((section) => (
        <PassportSection
          key={section.title}
          title={section.title}
          params={section.params}
          isEdit={isEdit}
          onValueChange={onValueChange}
        />
      ))}
    </div>
  );
}